// extracted by mini-css-extract-plugin
export default {"container":"tSBzA2","externalLinksSubtitle":"aG6Wlt","contentSeparator":"PJi6ga"};